export default __webpack_public_path__ + "assets/textures/boschFloor1.png";
